import { useSelector } from "react-redux";
import { AppStore } from "../../store";
import { CommonValuesState } from "../../types/common-values";
import { selectCommonValuesState } from "./common-values.slice";

export const useGetCommonValuesState = () => {
  return useSelector<AppStore, CommonValuesState>(selectCommonValuesState);
};
